module.exports = __webpack_public_path__ + "media/images/lb/970-7a8ac80c8ac0c24feefd0884818818d0.svg";